import React from 'react'
import styled from 'styled-components'
import { Avatar, BodyLargeBold } from 'prospect-path-base'

import Team from '../Team'

import Avatar1 from '../../../images/avatars/1.png'
import Avatar2 from '../../../images/avatars/2.png'
import Avatar3 from '../../../images/avatars/3.png'
import Avatar4 from '../../../images/avatars/4.png'

const Title = styled(BodyLargeBold)`
  margin: 0 0 0.75rem 0;
`

const Teams = (props) => (
  <section {...props}>
    <Title as="h4">Your teams</Title>

    <Team 
      title="Acme corp"
      avatars={[
        <Avatar src={Avatar1} size={40} />,
        <Avatar src={Avatar2} size={40} />,
        <Avatar src={Avatar3} size={40} />,
        <Avatar src={Avatar4} size={40} />,
      ]}
    />
  </section>
)

export default Teams